import { bbAxios } from '@bb/session-manager';

import {
  TENANT_MANAGEMENT_CHANGE_ENDPOINT,
  TENANT_MANAGEMENT_CURRENT_ENDPOINT,
  TENANT_MANAGEMENT_CREATE_ENDPOINT,
  TENANT_MANAGEMENT_LIST_ENDPOINT,
} from '../endpoints.config';

export async function GetCurrentTenant() {
  const { data } = await bbAxios.get(TENANT_MANAGEMENT_CURRENT_ENDPOINT);
  return data;
}

export async function GetTenants() {
  const { data } = await bbAxios.get(TENANT_MANAGEMENT_LIST_ENDPOINT);
  return data;
}

export async function ChangeTenant(id, socketId) {
  const { data } = await bbAxios.put(TENANT_MANAGEMENT_CHANGE_ENDPOINT(id), { socketId });
  return data;
}

export async function CreateTenant(data) {
  const { data: resp } = await bbAxios.post(
    `${TENANT_MANAGEMENT_CREATE_ENDPOINT}?async=true`,
    data
  );
  return resp;
}
